import { render } from "./FileDropzoneTypeComponent.vue?vue&type=template&id=502b15b7&scoped=true"
import script from "./FileDropzoneTypeComponent.vue?vue&type=script&lang=js"
export * from "./FileDropzoneTypeComponent.vue?vue&type=script&lang=js"

import "./FileDropzoneTypeComponent.vue?vue&type=style&index=0&id=502b15b7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502b15b7"]])

export default __exports__